const weights = {
  normal: "normal",
  bold: "bold",
  light: "light",
}

export default weights
